  <template>
    <div class="home">
      <div class="rotationChart">
        <el-image :src='lb1' style="width:100%;height:390px;  margin-bottom: 8px;" fit="fill"></el-image>
      </div>
      <div style="width: 100%;margin: 0 auto;text-align: center;background-color: #F1F3F5" v-if="sliderData.length > 0">
        <horizontal-text-slider :slider-data="sliderData" @click="onClick" :totalWidth="2200" :amount="1" :height="40"
          style="background-color: #fff; width: 100%;">
        </horizontal-text-slider>
      </div>
      <div class="content">
        <div class="content_top">
          <div class="content_top_content">
            <div class="content_top_content_left">
              <!-- 标签页占满整行 -->
              <div class="tab-button-group">
                <div v-for="(item, index) in contentList1" :key="index" class="tab-button"
                  :class="{ active: content1Name === item.value }" @click="switchTab(item.value)">
                  {{ item.label }}
                </div>
              </div>

              <!-- 公告内容区域统一用 white-bg 类 -->
              <div class="tab-content-container">
                <!-- <div style="height: 9px;background-color: #fff;"> </div> -->
                <!-- 通知公告 -->
                <div v-if="content1Name === 'tzgg'" class="white-bg">
                  <!-- 只展示前 10 条公告 -->
                  <div :underline="false" v-for="(item, index) in tzggList" :key="index" style="height: 46px;">
                    <div :class="{ 'toolitem': true, 'action': toolaction === index }" @click="goNewsDetail(item.id)">
                      <div style="display: flex;justify-content: space-between;align-items: center;font-size: 14px">
                        <div style="width: 230px;margin-left: 10px;">
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                            <el-button type="text" style="color: #000;">
                              {{ item.name.length > 37 ? item.name.slice(0, 37) + '...' : item.name }}
                            </el-button>
                          </el-tooltip>
                        </div>
                        <div style="width: 90px;margin-left: 10px;">{{ item.createTime.substring(0, 10) }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- 只有超过等于10条才显示 查看更多 按钮 -->
                  <div v-if="tzggList.length >= 10" style="text-align: center; margin-top: 10px;">
                    <el-button type="text" @click="contentMore">查看更多 ></el-button>
                  </div>
                </div>

                <!-- 招标公告 / 招募公告 -->
                <div v-if="content1Name === 'zbgg' || content1Name === 'zmgg'" class="white-bg">
                  <div :underline="false" v-for="(item, index) in (content1Name === 'zbgg' ? zbggList : zmggList)"
                    :key="index" style="height: 46px;">
                    <div :class="{ 'toolitem': true, 'action': toolaction === index }" @click="goToPage(item.id)">
                      <div style="display: flex;justify-content: space-between;align-items: center;font-size: 14px">
                        <div style="width: 230px;margin-left: 10px;">
                          <el-tooltip class="item" effect="dark" :content="item.ggName" placement="bottom">
                            <el-button type="text" style="color: #000;">
                              {{ item.ggName.length > 37 ? item.ggName.slice(0, 37) + '...' : item.ggName }}
                            </el-button>
                          </el-tooltip>
                        </div>
                        <div style="width: 90px;margin-left: 10px;">{{ item.ggStartTime.substring(0, 10) }}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="(content1Name === 'zbgg' && zbggList.length >= 10) || (content1Name === 'zmgg' && zmggList.length >= 10)"
                    style="text-align: center; margin-top: 10px;">
                    <el-button type="text" @click="contentMore">查看更多 ></el-button>
                  </div>

                </div>
              </div>
            </div>
            <div class="content_top_content_right">
              <!-- 上方大图 -->
              <div class="top-image">
                <el-image :src="homeImage" style="width: 100%; height: 80px; padding: 0;" fit="fill"></el-image>
              </div>

              <!-- 中间三排两列图片 + 文本 -->
              <div class="grid-images">
                <div v-for="(item, index) in gridImages" :key="index" class="grid-item" @click="content2More(item)">
                  <div class="image-wrapper">
                    <el-image :src="item.url" style="width: 100%; height: 80px;" fit="cover"></el-image>
                  </div>
                  <div class="text-below" @click="handleGridTextClick(item)">
                    {{ item.text || '默认文案' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content_BusinessModule">
          <div style="margin: 0 auto;width: 1360px">
            <h2 style="color:#333333; margin-top: 20px;text-align: center;">业务模块</h2>
            <div
              style="width: 100%;height: 20px;font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;margin-top: 11px;
font-weight: normal;font-size: 20px;color: #999999;line-height: 20px;text-align: center;font-style: normal;text-transform: none;">
              全场景解决您的使用需求，构建产业生态链</div>
            <div style="display: flex;justify-content: space-between;flex-wrap: wrap">
              <div class="content_BusinessModule_content" style="border-radius: 15px 15px 15px 15px"
                v-for="(item, index) in businessList" :key="index" @click="businessMore(item)">
                <el-image :src="item.url" class="business-image"
                  style="width:100%;height:inherit;border-radius: 15px 15px 0 0" fit="fill"></el-image>
                <div style="display: flex;justify-content: space-between">
                  <div>
                    <div
                      style="display: flex; justify-content: left; align-items: center; gap: 10px;margin: 16px 0 0 24px;">
                      <div
                        style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30; font-weight: normal; font-size: 24px; color: #13319F; line-height: 18px; text-align: center; font-style: normal; text-transform: none;">
                        {{ item.label }}
                      </div>
                      <div
                        style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30; font-weight: normal; font-size: 16px; color: #13319F; line-height: 14px; text-align: center; font-style: normal; text-transform: none; padding-top: 1px; /* 向下偏移3px，可根据需求调整 */">
                        {{ item.val }}
                      </div>
                    </div>
                    <br />
                    <span style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
        font-weight: normal;
        font-size: 14px;
        color: #999999;
        line-height: 1px;
        margin-left: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        position: relative;
        top: -5px;" v-html="item.value">
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 遮罩层 -->
      <div class="login-mask" v-if="logoDialog" @click="closeLoginDialog"></div>
      <!-- 登录弹窗 -->
      <div class="login-dialog" v-if="logoDialog" @keydown.esc="closeLoginDialog">
        <div class="dialog-header">
          <span class="title">请选择登录方式</span>
          <div class="close-icon" @click="closeLoginDialog">
            <img src="@/assets/guanbi.png" alt="关闭" />
          </div>
        </div>
        <div class="login-options">
          <div class="login-option" @click="selectLogo(2)">
            <span>供应商登录</span>
          </div>
          <div class="login-option" @click="selectLogo(3)">
            <span>采购人登录</span>
          </div>
          <div class="login-option" @click="selectLogo(5)">
            <span>平台方登录</span>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>

import lb from '@@/assets/images/lunbo1.jpg'
import xcyc from '@@/assets/images/xcyc.jpg'
import xcwl from '@@/assets/images/xcwl.jpg'
import xcyp from '@@/assets/images/xcyp.jpg'
import zqyl from '@@/assets/images/zqyl.png'
import fjwz from '@@/assets/images/fjwz.png'
import xcys from '@@/assets/images/xcys.jpg'
import lb1 from '@@/assets/images/lunbo1(1).png'

import {
  noticeApi,
  lbimages,
  getLoginStatus,
  getGgListHome,
  getZmggListTwoMonth,
} from "@@/api/api";
import Cookies from "js-cookie";
import HorizontalTextSlider from "@/views/HorizontalTextSlider.vue";

export default {
  components: { HorizontalTextSlider },
  // comments:{lb},
  computed: {
    xcys() {
      return xcys
    },
    lb() {
      return lb
    },
    lb1() {
      return lb1
    },
    xcyc() {
      return xcyc
    },
    xcwl() {
      return xcwl
    },
    xcyp() {
      return xcyp
    },
    zqyl() {
      return zqyl
    },
    fjwz() {
      return fjwz
    },
  },
  data() {
    return {
      homeImage: require('@/assets/images/homeImage/home1.png'),
      gridImages: [
        { url: require('@/assets/images/homeImage/home2.png'), text: '旭诚云采', label: "旭诚云采", id: "1" },
        { url: require('@/assets/images/homeImage/home3.png'), text: '旭诚云市', label: "旭诚云市", id: "5" },
        { url: require('@/assets/images/homeImage/home4.png'), text: '旭诚物流', label: "旭诚云市", id: "2" },
        { url: require('@/assets/images/homeImage/home5.png'), text: '评标系统', label: "旭诚云市", id: "7" },
        { url: require('@/assets/images/homeImage/home6.png'), text: '供应链金融 联易融', label: "供应链金融-联易融", id: "4" },
        { url: require('@/assets/images/homeImage/home7.png'), text: '供应链金融 中企云链', label: "供应链金融-中企云链", id: "9" }
      ],
      sliderData: [
        /*{
          title: '公司名称变更通知:“河北旭诚智联科技有限公司”因业务需要名称变更为“河北旭诚智联供应链有限公司”，特此通知!',
          id: '1782686195931680770'
        },*/
        /* {
           title: '重要通知：投标文件制作工具版本已更新，拟投标单位务必下载最新版的制作工具进行制作投标文件，如因使用旧版本造成的投标失败，一切后果自负。',
           id: '1836951262234980353'
         },*/
        {
          title: '供应商入库联系方式路径:点击“联系我们”或点击本条通知',
        },
        {
          title: '供应商入库联系方式路径:点击“联系我们”或点击本条通知',
        },
      ],
      /** content **/
      content1Name: 'zbgg',
      tzggList: [],
      zbggList: [],
      zmggList: [],
      content2Name: '',
      contentList1: [
        { label: "招标公告", id: "2", value: 'zbgg' },
        { label: "通知公告", id: "1", value: 'tzgg' },
        { label: "招募公告", id: "1", value: 'zmgg' },
      ],
      contentList2: [
        { label: "快捷入口", id: "1", value: '' },
      ],
      contentRight: [
        { label: "旭诚云采", id: "1", value: '' },
        { label: "旭诚云市", id: "5", value: '' },
        { label: "旭诚物流", id: "2", value: '' },
        { label: "评标系统", id: "7", value: '' },
        // {label: "专家入库", id: "8", value: ''},
        { label: "供应链金融-联易融", id: "4", value: '' },
        { label: "供应链金融-中企云链", id: "9", value: '' },
        // {label: "技术支持", id: "6", value: ''},
        { label: "帮助中心", id: "3", value: '' },

      ],
      content2More(val) {
        if (val.id === '3') {
          this.$router.push({ path: '/help', });
        } else if (val.id === '7') {
          window.location.href = `${process.env.VUE_APP_LOGINURL}#/login2`
        } else if (val.id === '8') {
          this.$router.push({ path: '/zjRegister' })
        } else if (val.id === '9') {
          window.open(`https://www.yljr.com/login.xhtml?from=plateForm`)
        } else if (val.id === '5') {
          window.open(`https://xcsw-pc.xcsw.net:7443/`)
        } else if (val.id === '4') {
          window.open('https://xczl.xyc.llschain.com/#/')
        } else if (val.id === '6') {
          window.open('https://www.yljr.com/login.xhtml?from=plateForm')
        } else if (val.id === '2') {
          window.open(`https://hz.zczy56.com/`)
        } else {
          if (Cookies.get('Admin-Token')) {
            if (val.id === '1') {
              location.href = `${process.env.VUE_APP_OLDHOME}`
            } else if (val.id === '5') {
              getLoginStatus().then(res => {
                let data = res.data
                if (data.identity === "gys") {
                  // 供应商
                  if (data.state) {
                    window.open(`/redirect?r=https://xcsw-multishop.sjzszjjt.com:7443/`)
                  } else {
                    this.$message.warning('未通过主体认证或入库审核还未通过')
                  }
                } else if (data.identity === "ptf") {
                  // 平台方
                  window.open(`/redirect?r=https://xcsw-platform.sjzszjjt.com:7443/`)
                } else if (data.identity === "cgr") {
                  // 采购人
                  if (data.state) {
                    window.open(`/redirect?r=https://xcsw-pc.sjzszjjt.com:7443/`)
                  } else {
                    this.$message.warning('未通过主体认证或平台审核还未通过')
                  }
                }
              }).catch()
            }
          } else {
            this.logoDialog = true
          }
        }
      },
      /** business **/
      businessList: [
        { label: "旭诚云采", id: "1", value: '集中采购&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公平公正&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合法合规', val: '招投标、电子采购平台', url: require('@/assets/images/homeImage/home8.png') },
        { label: "旭诚云市", id: "4", value: '日常用品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;质量保证&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价格优惠', val: '企业采购商城', url: require('@/assets/images/homeImage/home10.png') },
        { label: "供应链金融-联易融", id: "3", value: '区块链技术&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于真实交易&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;操作简便', val: '更灵活的融资模式', url: require('@/assets/images/homeImage/home9.png') },
        { label: "供应链金融-中企云链", id: "5", value: '区块链技术&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于真实交易&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;操作简便', val: '更灵活的融资模式', url: require('@/assets/images/homeImage/home12.png') },
        { label: "旭诚物流", id: "2", value: '物联网新技术&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数据实时共享&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大数据可视化', val: '运输仓储一体化平台', url: require('@/assets/images/homeImage/home11.png') },
        { label: "废旧物资交易平台", id: "6", value: '敬请期待', val: '敬请期待......', url: require('@/assets/images/homeImage/home13.png') }
      ],
      /** bottom **/
      bottomList1: [
        { label: '住建集团', url: '' },
        //{label:'城发投集团',url:''},
        { label: '石建工集团', url: '' },
        //{label:'交投集团',url:''},
      ],
      bottomList2: [
        { label: '中国招投标公共服务平台', url: 'http://www.cebpubservice.com/' },
        { label: '河北省招投标公共服务平台', url: 'http://www.hebeieb.com/' },
        { label: '河北省投资项目在线市批监管平台', url: 'http://tzxm.hbzwfw.gov.cn/sbglweb/index' },
        { label: '河北省政府采购网', url: 'http://www.ccgp-hebei.gov.cn/province/' },
      ],
      toolaction: '',
      imagelist: [{ pictureUrl: 'http://www.xcsw.net:1080/m/test/static/image/海报.jpg' }],//轮播图列表
      logoDialog: false
    };
  },
  created() {
    console.log('sliderData:', this.sliderData);
    this.getUrl();
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  watch: {
    logoDialog(newVal) {
      if (newVal) {
        // 打开弹窗时禁止滚动
        document.body.style.overflow = 'hidden';
        // 打开弹窗时绑定事件
        window.addEventListener('keydown', this.handleKeydown);
      } else {
        // 关闭弹窗时恢复滚动
        document.body.style.overflow = 'auto';
        // 关闭弹窗时解绑事件
        window.removeEventListener('keydown', this.handleKeydown);
      }
    },
  },
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    switchTab(val) {
      this.content1Name = val;
      this.contentLeft({ name: val }); // 触发原有逻辑
    },
    closeLoginDialog() {
      this.logoDialog = false;
      // 关闭弹窗时恢复滚动
      document.body.style.overflow = 'auto';
    },
    async getUrl() {
      let str = window.location.href
      //dzzb.sjzszjjt.com
      //http://192.168.1.11/home
      if (str.indexOf("dzzb.sjzszjjt.com") !== -1) {
        await this.$alert('重要通知:旭诚商务平台于2025年1月1日更换新网址(www.xcsw.net),请前往新网址进行登录', '', {
          confirmButtonText: '跳转',
          showClose: false,
          callback: () => {
            window.location.replace('https://www.xcsw.net/home');
          }
        })
      } else {
        this.notice()
        this.lbimages()
        this.getGgList('zbgg');
      }
    },
    onClick() {
      //跳转路由/ourself
      this.$router.push('/ourself')
    },
    //查询轮播图图片
    lbimages() {
      lbimages().then(res => {
        //console.log(res)
        if (res.code == 200) {
          this.imagelist = res.data.items
        }
      })
    },
    /**  content_top
     * notice 通知公告
     * goNewsDetail 跳转到通知公告详情
     */
    contentLeft(tab) {
      if (tab.name === 'tzgg') {
        this.notice()
      } else if (tab.name === 'zbgg') {
        this.getGgList('zbgg');
      } else if (tab.name === 'zmgg') {
        this.getZmggList('zmgg');
      }
    },
    getZmggList(val) {
      let data = { ggAnnouncement: val }
      getZmggListTwoMonth(data).then((res) => {
        if (res.code == 200) {
          this.zmggList = res.data.items.slice(0, 10); // 赋值前就截取前10条数据
        }
      });
    },
    notice() {
      noticeApi({ page: 1, pageSize: 10 }).then(res => {
        if (res.code == 200) {
          this.tzggList = res.data.items.slice(0, 10); // 赋值前就截取前10条数据
        }
      })
    },
    goNewsDetail(id) {
      let routeData = this.$router.resolve({ path: "/newsDetail", query: { id: id } });
      //必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    getGgList(val) {
      let data = { ggAnnouncement: val }
      getGgListHome(data).then((res) => {
        if (res.code == 200) {
          this.zbggList = res.data.items.slice(0, 10); // 赋值前就截取前10条数据
        }
      });
    },
    // 跳转公告详情
    goToPage(id) {
      let routeData = this.$router.resolve({ path: "/ggDetail", query: { id: id } });
      window.open(routeData.href, '_blank');
      /* if (Cookies.get('Admin-Token')){
        //必要操作，否则不会打开新页面
        let routeData = this.$router.resolve({path: "/ggDetail", query: {id: id}});
        window.open(routeData.href, '_blank');
      }else {
        this.$message('登录之后查看详情');
      }*/
    },
    contentMore() {
      if (Cookies.get('Admin-Token')) {
        if (this.content1Name === 'tzgg') {
          this.$router.push({ path: '/notice', });
          //top.window.location.replace(`${process.env.VUE_APP_OLDHOME}/notice`)
          //location.href = `${process.env.VUE_APP_OLDHOME}`
          //this.notice()
        } else if (this.content1Name === 'zbgg') {
          this.$router.push({ path: '/about', });
          //top.window.location.replace(`${process.env.VUE_APP_OLDHOME}/about`)
          //location.href = `${process.env.VUE_APP_OLDHOME}`
          //this.getGgList('zbgg');
        } else if (this.content1Name === 'zmgg') {
          this.$router.push({ path: '/about', });
          //top.window.location.replace(`${process.env.VUE_APP_OLDHOME}/about`)
          //location.href = `${process.env.VUE_APP_OLDHOME}`
          //this.getGgList('zbgg');
        }
      } else {
        this.$message('登录之后查看更多');
      }
    },
    selectLogo(val) {
      this.toPage('/login', val);
    },
    // 页面跳转
    toPage(path, val) {
      if (path === '/guarantee') window.open('http://www.gzzczb.com/guarantee/')
      this.$router.push({ path: path, query: { type: val } });
    },
    businessMore(val) {
      if (val.id === '3') {
        return window.open(`https://xczl.xyc.llschain.com`)
      } else if (val.id === '2') {
        return window.open(`https://hz.zczy56.com`)
      } else if (val.id === '5') {
        return window.open(`https://www.yljr.com/login.xhtml?from=plateForm`)
      } else if (val.id === '6') {
        return this.$message.info("敬请期待。。。")
      } else if (val.id === '4') {
        return window.open(`https://xcsw-pc.xcsw.net:7443/`)
      }


      if (Cookies.get('Admin-Token')) {
        if (val.id === '1') {
          location.href = `${process.env.VUE_APP_OLDHOME}`
        }
      } else {
        this.logoDialog = true
      }
    },
    /** 友情链接
     * friendlyLinks
     */
    friendlyLinks(val) {
      window.open(val.url, '_blank');
    },
  },
};
</script>
<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.rotationChart {
  background-color: #F1F3F5;
}

.content_top_content_right {
  width: 328px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-left: 16px;
  padding: 16px;
  box-sizing: border-box;
  position: relative; // 父容器设为相对定位
}

.top-image {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 328px;
  height: 80px;
}

.grid-images {
  position: absolute;
  top: 122px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.grid-item {
  width: 138px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-wrapper {
  width: 138px;
  height: 88px;
  overflow: hidden;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.text-below {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #333;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0px;

  &:hover {
    color: #409EFF;
  }
}

.tab-button-group {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  padding: 0;
  overflow: hidden;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 20px;
}

.tab-button {
  flex: 1;
  min-width: 0;
  padding: 12px 0;
  text-align: center;
  background-color: #ffffff;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 32px;

  /* 默认所有按钮只有左右内边距 */
  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:nth-child(2) {
    border-radius: 0; // 中间按钮全部直角
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &:hover {
    background-color: #409EFF;
    color: white;
  }

  &.active {
    background-color: #409EFF;
    color: white;
    font-weight: bold;
  }
}

.white-bg {
  background-color: #fff;
  padding: 15px;
  border-radius: 0 4px 4px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-top: 0px;
  min-height: 499px; // 添加这一行
}

// 登录遮罩层样式
.login-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // 半透明黑色背景
  z-index: 1999; // 确保在弹窗下方
  transition: opacity 0.3s ease; // 添加淡入淡出效果
}

// 登录弹窗样式
.login-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 720px;
  max-width: 90%;
  background-color: white; // 弹窗背景为白色
  border-radius: 4px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 2000; // 确保在遮罩层上方
  transition: all 0.3s ease; // 添加过渡效果

  // 弹窗标题栏
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 84px;
    padding: 0 30px;
    background: url(@/assets/longing_title.png) 100%/cover no-repeat;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 22px;
      font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    }

    .close-icon {
      cursor: pointer;

      img {
        width: 19px;
        height: 19px;
      }
    }
  }

  // 登录选项
  .login-options {
    padding: 24px 0;

    .login-option {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      width: 400px;
      max-width: 80%;
      margin: 24px auto;
      border: 1px solid rgba(220, 220, 220, 1);
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      transition: all 0.3s ease;

      span {
        color: rgba(51, 51, 51, 1);
        font-size: 20px;
        font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
      }

      &:hover {
        background-color: #409EFF;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);

        span {
          color: white;
        }
      }
    }
  }
}

// 防止遮罩层和弹窗出现滚动条
body.modal-open {
  overflow: hidden;
}

.content_top {
  background-color: #F1F3F5;
  padding: 11px;
}

.content_top_content {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.content_top_content_left {
  width: 1016px;
}

.content_top_content_left_content {
  border-right: 1px solid #C7C7C7;
  height: 220px;
  overflow: auto;
  padding: 0 10px;
  padding-left: 80px;
}

.content_top_content_right {
  width: 328px;
  height: 585px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-left: 16px;
}

.content_top_content_right_content {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  padding-left: 25px;
}

.content_top_content_right_content-DIV {
  margin-right: 50px !important;
}

.content_top_content_right_content div {
  padding: 20px 30px;
  margin: 10px;
  background-color: #13319f;
  color: #ffffff;
  border-radius: 4px;
}

.content {
  background-color: #F1F3F5;
}

.content_BusinessModule_content {
  width: 400px;
  background-color: #f8f8f8;
  border-right: 20px;
  margin-top: 20px;
  padding: 0 0 20px 0;
  margin-bottom: 40px;

}

.business-image {
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}

.bottom {
  background-color: #f8f8f8;
  padding: 20px;
  margin-top: 20px;
}

.bottom-content {
  margin: 0 auto;
  width: 800px;
  cursor: pointer;
}

.bottom-content div {
  margin: 5px;
  font-size: 14px;

}

.toolitem {
  transition: all 0.5s;
  padding: 0px;
  cursor: pointer;
  color: #333333;
  position: relative;
}

.toolitem.action,
.toolitem:hover {
  color: #0a84ff;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item,
::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav,
::v-deep .el-tabs--card>.el-tabs__header {
  border: none;
  font-size: 19px;
}
</style>
